import { module } from 'angular';

import { AlertService, default as alertServiceName } from './alert.service';

export default module('contact.agent.core.alert', [])
  .run([alertServiceName, () => {}])
  .service(alertServiceName, AlertService).name;
